export default __webpack_public_path__ + "static/media/modal_sliding_door.19d9cff6.png";